import React, { useContext, useEffect, useState, useCallback, useMemo } from 'react';
import { DefaultContext } from '../../../../contexts/default';
import PageWrapper from '../../../../layout/PageWrapper/PageWrapper';
import SubHeader, { SubHeaderLeft, SubHeaderRight } from '../../../../layout/SubHeader/SubHeader';
import Breadcrumb from '../../../../components/bootstrap/Breadcrumb';
import { demoPages } from '../../../../menu';
import Button from '../../../../components/bootstrap/Button';
import { ACCESS_LEVEL } from '../../../../types/roles';
import Page from '../../../../layout/Page/Page';
import Card, { CardBody } from '../../../../components/bootstrap/Card';
import SelectEstablishment from '../../../../components/MyCustom/SelectEstablishment';
import TableCustom from '../../../../components/MyCustom/TableCustom';
import InsumosDB from '../../../../database/wrappers/insumos';
import { orderBy } from 'firebase/firestore';
import ModalRegisterInsumo from '../../../../components/modals/Insumo/InsumoRegister';

const Insumo = () => {
  const { accessLevel, estabSelected, settings } = useContext(DefaultContext);

  const [openModalRegister, setOpenModalRegister] = useState(false);
  const [insumos, setInsumos] = useState([])
  const [insumoSelected, setInsumoSelected] = useState(null)

  useEffect(() => {
    if (!estabSelected) return;
    const onSubscribe = new InsumosDB(estabSelected).on(setInsumos, orderBy('name', 'asc'));
    return onSubscribe;
  }, [estabSelected])

  const handleOpenModalRegister = useCallback(() => {
    setOpenModalRegister(prev => !prev);
    if (openModalRegister) {
      setInsumoSelected('');
    }
  }, [openModalRegister]);


  const handleOpenModalEdit = useCallback((item) => {
    setInsumoSelected(item);
    handleOpenModalRegister()
  }, [])

  const rowsRender = useMemo(() => insumos.map(item => ({
    id: item.id,
    type: item.type,
    name: item.name,
    sku: item.sku,
    unit: item.unit,
  })), [insumos])

  const columns = useMemo(() => ([
    {
      label: 'Nome',
      field: 'name',
    },
    {
      label: 'Tipo',
      field: 'type',
    },
    {
      label: 'Unidade',
      field: 'unit',
    },
    {
      label: 'Ações',
      field: 'actions',
      format: row => (
        <div className='w-50 d-flex justify-content-between gap-2'>
          <Button
            color="light"
            icon="edit"
            shadow="sm"
            hoverShadow="sm"
            size="sm"
            onClick={() => handleOpenModalEdit(row)}
          />
        </div>
      ),
      noExport: true
    },
  ]), [settings, handleOpenModalEdit])

  return (
    <>
      <PageWrapper title={demoPages.pdvMenu.subMenu.complement.text}>
        <SubHeader>
          <SubHeaderLeft>
            <Breadcrumb
              list={[
                { title: 'Cadastros', to: '/pdv/insumes' },
                {
                  title: 'Insumos',
                  to: '/pdv/insumes',
                },
              ]}
            />
          </SubHeaderLeft>
          <SubHeaderRight>
            {accessLevel >= ACCESS_LEVEL.MANAGER &&
              <Button
                color='primary'
                icon='plus'
                shadow="sm"
                hoverShadow="sm"
                onClick={handleOpenModalRegister}
              >
                Cadastrar
              </Button>}
          </SubHeaderRight>
        </SubHeader>
        <Page container="fluid">
          <Card>
            <CardBody className='table-responsive p-5'>
              <SelectEstablishment />
              <TableCustom
                columns={columns}
                rows={rowsRender}
                fileName={'Insumos'}
              />
            </CardBody>
          </Card>
        </Page>
      </PageWrapper>

      <ModalRegisterInsumo
        open={openModalRegister}
        handleOpen={handleOpenModalRegister}
        insumoSelected={insumoSelected}
      />
    </>
  );
};

export default Insumo;
